import get from 'lodash/get';

export default ({ typography, color, fontSize }) => ({
  errorContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  dialog: {
    border: `1px solid ${color.error}`,
    borderRadius: 5,
    paddingTop: 27,
    paddingBottom: 36,
    paddingLeft: 24,
    paddingRight: 24,
  },
  errorIcon: {
    color: get(color, 'error'),
  },
  title: {
    '& svg': {
      position: 'relative',
      top: 4,
      marginRight: 8,
    },
    fontSize: `${fontSize.large}!important`,
    fontFamily: `${typography.pageTitle}!important`,
    lineHeight: '24px',
    paddingBottom: 21,
  },
  message: {
    fontSize: `${fontSize.bodyText}!important`,
    fontFamily: `${typography.bodyText}!important`,
  },
});

